<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>LISTADO DE PROCESOS PRIMARIOS</h6>
        </div>
        <div class="col">
          <button  class="btn bg-gradient-success float-end" @click="$router.push('/create-primary-process')"> Crear nuevo proceso primario</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="row justify-content-end">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <input type="text" class="form-control" placeholder="Buscar por nombre" v-model="pagination.search" @keyup="manualSearch">
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
          <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover border table-bordered">
          <thead>
          <tr>
            <th scope="col">Título</th>
            <th scope="col">Descripción</th>
            <th scope="col">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in arrayProcess" :key="index">
            <td>{{ item.title }}</td>
            <td>
              <div class="limited-width_70">
                {{ item.description }}
              </div>
            </td>
            <td>
              <button class="btn btn-outline-success btn-sm mb-0" @click="viewDetail(item)">
               ver
              </button>
              <button class="btn btn-outline-info btn-sm mb-0 ms-2" @click="editItem(item)">
                Editar
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <p class="text-xs font-weight-bold mb-0">total rows: {{pagination.totalRows}}</p>
        </div>
        <div>
          <v-pagination
              v-model="pagination.page"
              :pages="pagination.pages"
              :range-size="1"
              active-color="#DCEDFF"
              @update:modelValue="reloadPaginate"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {get} from "@/utils/httpRequest";

export default {
  data: () => ({
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
    arrayProcess: [],
  }),
  mounted() {
    this.getData()
  },
  methods: {
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    async getData(){
      const {data} = await get(`main-process?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`, null)
      this.arrayProcess = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },

    viewDetail(item){
      this.$router.push({name:'detail-primary-process', query: {id: item._id}})
    },

    editItem(item){
      this.$router.push({name:'edit-primary-process', query: {id: item._id}})
    }
  }
}
</script>
<style scoped>

</style>
